<template>
  <fy-form :model="form_info" :rules="rules" class="fy-form-login-pc" ref="form" v-if="!isInit">
    <div class="wrap1920" id="indexContent">
      <div class="wrap">
        <div class="tourism_main">
          <login-logo></login-logo>
          <div class="logonRight">
            <p>
              <img src="@/assets/images/html/logon01.jpg">
            </p>
            <div class="reg_top_line_pc">
              <em>1. 输入基本信息</em>
              <i>></i>
              <p>2. 设置密码</p>
            </div>
            <p class="p2">
              <em></em>
              <fy-form-item :inner_width="'100%'" :prop="fields.passwd.field_enname">
                <fy-input
                  :placeholder="fields.passwd.field_placeholder"
                  type="password"
                  v-model.trim="form_info.passwd"
                ></fy-input>
              </fy-form-item>
            </p>
            <p class="p2">
              <em></em>
              <fy-form-item :inner_width="'100%'" :prop="fields.confirmPasswd.field_enname">
                <fy-input
                  :placeholder="fields.confirmPasswd.field_placeholder"
                  type="password"
                  v-model.trim="form_info.confirmPasswd"
                ></fy-input>
              </fy-form-item>
            </p>
            <a @click="submit()" class="submitBtn" href="javascript:void(0);">提交并完成注册</a>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </fy-form>
</template>
<script>
import { LoginLogo } from '@/pages/components'
import { login } from '@/api/base'
export default {
  name: 'Regist2',
  componentName: 'Regist2',
  components: {
    LoginLogo
  },
  data () {
    return {
      url: 'member/regist2',
      form_info: {
        username: '',
        name: '',
        passwd: '',
        code: '',
        confirmPasswd: ''
      },
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      fields: {},
      rules: {}
    }
  },
  created () {
    this.$pageField.init(this, 'fields', 'regist2').then(res => {
      this.isInit = false //异步加载完成后设置为true
      this.rules.confirmPasswd[0].confirmProp = 'passwd'
    })
    this.init_form_info()
  },
  methods: {
    submit () {
      //判断参数是否过期
      const user_info = this.$sessionStorageUtil.get('regist_user_info')
      if (!user_info) {
        this.$msg('参数过期，将回到注册步骤1，重新填写数据!', 'error')
        this.$router.push({
          name: 'regist'
        })
      } else {
        this.$refs.form.validate((valid, invalidFields) => {
          if (valid) {
            var loading = this.$loadingIndicator.eleOpen('信息审核中...')
            this.$myPost(this.url, this.form_info)
              .then(res => {
                const rcode = res.response.data.rcode
                if (rcode == 0) {
                  this.$sessionStorageUtil.remove('regist_user_info')
                  this.$sessionStorageUtil.set('next_message', '注册成功', 60 * 5)
                  this.$sessionStorageUtil.set('next_message_type', 'success', 60 * 5)
                  this.autoLogin(loading)
                } else {
                  if (rcode == 1010) {
                    this.$msg('失败：[' + res.status + ']' + res.response.data.messages[0].msg, 'error')
                  } else {
                    if (confirm('失败：[' + res.status + ']' + res.response.data.messages[0].msg + ' 是否回到注册步骤一重新填写数据?')) {
                      this.$router.push({
                        name: 'regist'
                      })
                    }
                  }
                  loading.close()
                }
              })
              .catch(err => {
                loading.close()
                this.$msg('[' + err.status + ']' + err.message, 'error')
              })
          } else {
            this.$msg(invalidFields[0].message, 'error')
          }
        })
      }
    },
    autoLogin (loading) {
      const Qs = require('qs')
      var url = 'oauth/token'
      let obj = {
        username: this.form_info.username,
        password: this.form_info.passwd,
        grant_type: 'password'
      }
      if (this.$sessionStorageUtil.get('weixin_public_no')) {
        obj.open_id = this.$sessionStorageUtil.get('open_id')
      }
      var param = Qs.stringify(obj)
      login(url, param)
        .then(res => {
          loading.close()
          this.$router.push({
            name: 'memberInfo'
          })
        })
        .catch(err => {
          loading.close()
          this.$msg('请求出错:[' + err.status + ']' + err.get_token_error, 'error')
        })
    },
    init_form_info () {
      // const user_info = JSON.parse(sessionStorage.getItem('regist_user_info'))
      const user_info = this.$sessionStorageUtil.get('regist_user_info')
      if (user_info && user_info.code && user_info.name && user_info.username) {
        this.form_info.code = user_info.code
        this.form_info.name = user_info.name
        this.form_info.username = user_info.username
      } else {
        this.$msg('参数错误或过期，将回到注册步骤1，重新填写数据!', 'error')
        this.$router.push({
          name: 'regist'
        })
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/user/regist2.vue